import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, path }) => {
  const siteTitle = "Raven | Immigration Support Network for Canada";
  const pageTitle = title ? `${title} | Raven` : siteTitle;
  const defaultDescription =
    "Raven Support Network helps immigrants and international students settle into Canada with relocation support, career guidance, and community integration.";

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta
        property="og:title"
        content={pageTitle}
      />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      {path && <meta property="og:url" content={`https://www.elijahsraven.ca${path}`} />}
      {path && <link rel="canonical" href={`https://www.elijahsraven.ca${path}`} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content="https://www.elijahsraven.ca/logo512.png" />
    </Helmet>
  );
};

export default SEO;
